import axios from 'axios';

// Sessão do quiosque da TV. O painel deixou de ser público (achado 9 da
// auditoria): o payload leva nome de motorista e placa. A TV se autentica como
// dispositivo fixo — token de 180 dias, revogável em Cadastros → Impressoras →
// Dispositivos conectados, igual ao agente de impressão.
//
// Instância própria de axios, sem os interceptors de api.js de propósito: um 401
// aqui não deve jogar a TV para /login, e sim pedir a ativação do dispositivo.
const http = axios.create({
    baseURL: '/api',
    // Mantém o cookie: administrador abrindo /painel na própria sessão não
    // precisa provisionar nada, basta ter PAINEL_VISUALIZAR.
    withCredentials: true,
});

const CHAVE_TOKEN = 'patio_painel_token';
const CHAVE_EXPIRA = 'patio_painel_expira';

export const tokenPainel = () => localStorage.getItem(CHAVE_TOKEN);

export const removerTokenPainel = () => {
    localStorage.removeItem(CHAVE_TOKEN);
    localStorage.removeItem(CHAVE_EXPIRA);
};

// Data de expiração do token do dispositivo (epoch ms), para a tela avisar que
// a validade está no fim antes de a TV simplesmente parar de atualizar.
export const expiracaoTokenPainel = () => Number(localStorage.getItem(CHAVE_EXPIRA)) || 0;

// Provisiona esta TV: login de um usuário com PAINEL_VISUALIZAR (perfil "Painel").
// Sem X-Client: web, então o back devolve o token no corpo em vez de cookie.
export const ativarDispositivo = async (login, senha) => {
    const { data } = await http.post('/auth/login', { login, senha, dispositivo: 'PAINEL' });
    if (!data?.token) {
        throw new Error('O servidor não devolveu token de dispositivo.');
    }
    localStorage.setItem(CHAVE_TOKEN, data.token);
    if (data.expiraEm) localStorage.setItem(CHAVE_EXPIRA, String(data.expiraEm));
    return data;
};

const cabecalhos = () => {
    const token = tokenPainel();
    return token ? { Authorization: `Bearer ${token}` } : {};
};

export const obterPainel = (tipo = 'DESCARGA') =>
    http.get('/painel', { params: { tipo }, headers: cabecalhos() }).then((r) => r.data);

export const obterParametrosPainel = () =>
    http.get('/parametros/interface', { headers: cabecalhos() }).then((r) => r.data);
